// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Redux Action types
 */
export enum ActionTypes {
    // App
    SAVE_APP_SETTINGS_SUCCESS = "SAVE_APP_SETTINGS_SUCCESS",
    ENSURE_SECURITY_TOKEN_SUCCESS = "ENSURE_SECURITY_TOKEN_SUCCESS",

    // Projects
    LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS",
    SAVE_PROJECT_SUCCESS = "SAVE_PROJECT_SUCCESS",
    ADD_ASSET_TO_PROJECT_SUCCESS = "ADD_ASSET_TO_PROJECT_SUCCESS",
    DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS",
    CLOSE_PROJECT_SUCCESS = "CLOSE_PROJECT_SUCCESS",
    LOAD_PROJECT_ASSETS_SUCCESS = "LOAD_PROJECT_ASSETS_SUCCESS",
    DELETE_PROJECT_ASSET_SUCCESS = "DELETE_PROJECT_ASSET_SUCCESS",
    UPDATE_PROJECT_TAG_SUCCESS = "UPDATE_PROJECT_TAG_SUCCESS",
    UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS = "UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS",
    UPDATE_TAG_LABEL_COUNTS_SUCCESS = "UPDATE_TAG_LABEL_COUNTS_SUCCESS",
    DELETE_PROJECT_TAG_SUCCESS = "DELETE_PROJECT_TAG_SUCCESS",
    SET_RECENT_PROJECTS = "SET_RECENT_PROJECTS",

    // Connections
    LOAD_CONNECTION_SUCCESS = "LOAD_CONNECTION_SUCCESS",
    SAVE_CONNECTION_SUCCESS = "SAVE_CONNECTION_SUCCESS",
    DELETE_CONNECTION_SUCCESS = "DELETE_CONNECTION_SUCCESS",

    // Assets
    SAVE_ASSET_METADATA_SUCCESS = "SAVE_ASSET_METADATA_SUCCESS",
    LOAD_ASSET_METADATA_SUCCESS = "LOAD_ASSET_METADATA_SUCCESS",
    REFRESH_ASSET_SUCCESS = "REFRESH_ASSET_SUCCESS",
    ANY_OTHER_ACTION = "ANY_OTHER_ACTION_SUCCESS",

    SHOW_ERROR = "SHOW_ERROR",
    CLEAR_ERROR = "CLEAR_ERROR",

    SET_TITLE = "SET_TITLE",

    UPDATE_PREBUILT_SETTINGS = "UPDATE_PREBUILT_SETTINGS",

    // Auth
    SET_USER = 'SET_USER',
    SIGN_OUT = 'SIGN_OUT',
    SET_LOADING = 'SET_LOADING',
    SET_ERROR = 'SET_ERROR',
    NEED_VERIFICATION = 'NEED_VERIFICATION',
    SET_SUCCESS = 'SET_SUCCESS',
    SET_ID_TOKEN = 'SET_ID_TOKEN',

    // Impersonation
    LOAD_ALLOWED_IMPERSONATION = 'LOAD_ALLOWED_IMPERSONATION',
    SET_IMPERSONATORS = 'SET_IMPERSONATORS',
    SET_IMPERSONATE_AS = 'SET_IMPERSONATE_AS',
}

export interface User {
    firstName: string;
    email: string;
    id: string;
    createdAt: any;
}

export interface AuthState {
    user: User | null;
    authenticated: boolean;
    loading: boolean;
    error: string;
    needVerification: boolean;
    success: string;
    idToken: string;
}

export interface SignInData {
    email: string;
    password: string;
}

// Actions
interface SetUserAction {
    type: typeof ActionTypes.SET_USER;
    payload: User;
}

interface SetLoadingAction {
    type: typeof ActionTypes.SET_LOADING;
    payload: boolean;
}

interface SignOutAction {
    type: typeof ActionTypes.SIGN_OUT;
}

interface SetErrorAction {
    type: typeof ActionTypes.SET_ERROR;
    payload: string;
}

interface NeedVerificationAction {
    type: typeof ActionTypes.NEED_VERIFICATION;
}

interface SetSuccessAction {
    type: typeof ActionTypes.SET_SUCCESS;
    payload: string;
}

interface SetIdTokenAction {
    type: typeof ActionTypes.SET_ID_TOKEN;
    payload: string;
}

export type AuthAction = SetUserAction | SetLoadingAction | SignOutAction | SetErrorAction | NeedVerificationAction | SetSuccessAction | SetIdTokenAction;
